import { Heading } from "@wix/design-system";
import { Trans } from "@wix/fe-essentials-standalone";
import { useTheme } from "@wix/picasso-common";
import { useMobile } from "../../../hooks/useMobile";

interface TitleProps {
  size: any;
}

export function Title({ size }: TitleProps) {
  const { theme } = useTheme();
  const isMobile = useMobile();

  return (
    <Heading size={size} className="landing-title">
      <Trans i18nKey={isMobile ? "landing.mobile.title" : "landing.title"}>
        <span
          style={{
            color: `var(${theme === "dark" ? "--wds-color-blue-200" : "--wds-color-blue-0"}, #4A2AE9)`,
          }}
        >
          your ideas
        </span>
      </Trans>
    </Heading>
  );
}
